define('areas/navigationmanager/services/mappings',["require", "exports", "areas/navigationmanager/models/bindable"], function (require, exports, Model) {
    "use strict";
    var Mapper = (function () {
        function Mapper() {
        }
        Mapper.mapNavigationFromDTO = function (data) {
            var instance = new Model.NavigationVM();
            instance.id = data.id;
            instance.networkMemberId = data.networkMemberId;
            instance.organizationId = data.organizationId;
            instance.memberType = data.memberType;
            instance.name = data.name;
            instance.description = data.description;
            instance.tree = data.tree;
            instance.model = this.parseNode(data.tree, null);
            instance.raw = data;
            return instance;
        };
        Mapper.parseNode = function (source, root) {
            var _this = this;
            var node = new Model.NavigationNodeVM();
            node.type = source.data.type;
            node.name = source.data.name;
            node.template = source.data.template;
            node.datakey = source.data.datakey;
            node.index = parseInt(source.data.index);
            node.icon = source.data.icon || null;
            node.color = source.data.color || null;
            node.openInDialog = source.data.openInDialog || false;
            node.openLinkInCurrentTab = source.data.openLinkInCurrentTab || false;
            node.disableNavigateToFirstChild = source.data.disableNavigateToFirstChild || false;
            node.key = source.data.key || null;
            node.showOnMobile = source.data.showOnMobile || false;
            node.useImage = source.data.useImage || false;
            node.imagePath = source.data.imagePath || null;
            node.defaultData = source.data.defaultData || null;
            node.imagePathSearchbar = source.data.imagePathSearchbar || null;
            node.permissionId = source.data.permissionId || null;
            node.groupId = source.data.groupId == null ? "" : source.data.groupId.toString();
            node.parent = root;
            node.groups = this.mapGroups(source.groups);
            if (node.type === "Sachgebiet")
                node.dependsOn = source.data.dependsOn;
            if (node.type === "Application")
                node.shopId = source.data.uID;
            if (node.type === "ApplicationLink")
                node.route = source.data.route;
            node.raw = source;
            var childs = new Array();
            Enumerable.From(source.children)
                .ForEach(function (x) {
                childs.push(_this.parseNode(x, node));
            });
            Enumerable.From(childs).OrderBy(function (x) { return x.index; }).ForEach(function (x) { return node.children.push(x); });
            return node;
        };
        Mapper.mapGroups = function (source) {
            var _this = this;
            var result = new Array();
            Enumerable.From(source)
                .ForEach(function (gr) {
                var group = _this.parseGroup(gr);
                result.push(group);
            });
            return result;
        };
        Mapper.parseGroup = function (source) {
            var group = new Model.NavigationGroupVM();
            group.key = source.key;
            group.title = source.title;
            group.description = source.description;
            group.index = source.index;
            group.autoSelectIndex = source.autoSelectIndex;
            group.icon = source.icon || null;
            group.useImage = source.useImage || false;
            group.imagePath = source.imagePath || null;
            group.showAddWidgets = source.showAddWidgets || false;
            group.hideFromSidenav = source.hideFromSidenav || false;
            group.showOnMobile = source.showOnMobile || false;
            group.alwaysShowTiles = source.alwaysShowTiles || false;
            return group;
        };
        return Mapper;
    }());
    return Mapper;
});

